import {AbstractControl} from '@angular/forms';

export function ValidateEmailList(control: AbstractControl) {
  // Copied from EMAIL_REGEXP from Angular source
  const regexp = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
  if (control.value !== null && control.value !== '') {
    const valid = control.value.split(/[,]/)
      .map((address: string) => address.trim())
      .reduce((total, address) => {
        return total && regexp.test(address);
      }, true);
    if (!valid) {
      return {
        email: true
      };
    }
  }
  return null;
}
